import React from "react";
import logo from "../../images/logo.png";
import { BsFacebook, BsGithub } from "react-icons/bs";
import { FaLinkedin, FaTwitter, FaRegHandPeace } from "react-icons/fa";
const Footer = () => {
  const d = new Date();
  const year = d.getFullYear();

  return (
    <footer>
      <div className="footer p-10 ">
        <div>
          <div className="space-y-3">
            <img src={logo} alt="" className="w-28" />
            <p>The most secure password wallet for all your applications.</p>
            <p className="text-primary">Get started Now</p>
          </div>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Solutions</span>
          <a className="link link-hover">Overview</a>
          <a className="link link-hover">Features</a>
          <a className="link link-hover">
            Tutorials
            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full ml-1 text-sm">
              New
            </span>
          </a>
          <a className="link link-hover">Release</a>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Developers</span>
          <a className="link link-hover">Overview</a>
          <a className="link link-hover">Features</a>
          <a className="link link-hover ">
            Tutorials
            <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full ml-1  text-sm">
              New
            </span>
          </a>
          <a className="link link-hover">Release</a>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Company</span>
          <a className="link link-hover">About Us</a>
          <a className="link link-hover">Careers</a>
          <a className="link link-hover">Press</a>
          <a className="link link-hover">News</a>
          <a className="link link-hover">Media Kit</a>
          <a className="link link-hover">Contact</a>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Resources</span>
          <a className="link link-hover">Blog</a>
          <a className="link link-hover">Newsletter</a>
          <a className="link link-hover">Events</a>
          <a className="link link-hover">Help center</a>
          <a className="link link-hover">Tutorials</a>
          <a className="link link-hover">Support</a>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Social</span>
          <a className="link link-hover">Twitter</a>
          <a className="link link-hover">Linkedin</a>
          <a className="link link-hover">Facebook</a>
          <a className="link link-hover">GitHub</a>
          <a className="link link-hover">AngelList </a>
        </div>
        <div className="text-accent font-semibold text-[16px]">
          <span className="footer-title">Legal</span>
          <a className="link link-hover">Terms </a>
          <a className="link link-hover">Privacy </a>
          <a className="link link-hover">Cookies </a>
          <a className="link link-hover">Licenses </a>
          <a className="link link-hover">Settings </a>
          <a className="link link-hover">Contact </a>
        </div>
      </div>
      <div className="footer items-center p-4 border-t border-t-gray-200 flex lg:justify-between flex-wrap md:justify-between sm:justify-between justify-center">
        <div className="items-center grid-flow-col font-semibold text-accent">
          <p>© {year} Knoct Inc. All rights reserved.</p>
        </div>
        <div className="grid-flow-col gap-4 md:place-self-center md:justify-self-end text-accent text-2xl ">
          <a href="#" className="hover:text-primary">
            <FaTwitter />
          </a>
          <a href="#" className="hover:text-primary">
            <FaLinkedin />
          </a>
          <a href="#" className="hover:text-primary">
            <BsFacebook />
          </a>
          <a href="#" className="hover:text-primary">
            <BsGithub />
          </a>
          <a href="#" className="hover:text-primary">
            <FaRegHandPeace />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
